var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language[
                                "system.certificate.certificateDescribe"
                              ],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "certificateDescribe"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.disabled || _vm.islock },
                            model: {
                              value: _vm.model.certificateDescribe,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "certificateDescribe", $$v)
                              },
                              expression: "model.certificateDescribe"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["system.certificate.system"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "systemCode"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                allowClear: "",
                                disabled: _vm.disabled || _vm.islock
                              },
                              on: { change: _vm.systemCodeChange },
                              model: {
                                value: _vm.model.systemCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "systemCode", $$v)
                                },
                                expression: "model.systemCode"
                              }
                            },
                            _vm._l(_vm.systemlist, function(item, index) {
                              return _c(
                                "a-select-option",
                                {
                                  key: index,
                                  attrs: { value: item.systemCode }
                                },
                                [_vm._v(_vm._s(item.systemName))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["system.certificate.cbCode"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "cbCode"
                          }
                        },
                        [
                          _c("a-auto-complete", {
                            attrs: {
                              allowClear: "",
                              disabled: _vm.disabled || _vm.islock,
                              "data-source": _vm.cbCodelist,
                              "filter-option": _vm.filterOption
                            },
                            on: { change: _vm.cbCodeChange },
                            model: {
                              value: _vm.model.cbCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "cbCode", $$v)
                              },
                              expression: "model.cbCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["system.certificate.mrcCode"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "mrcCode"
                          }
                        },
                        [
                          _c("a-auto-complete", {
                            attrs: {
                              allowClear: "",
                              disabled: _vm.disabled || _vm.islock,
                              "data-source": _vm.mrcCodelist,
                              "filter-option": _vm.filterOption
                            },
                            on: { change: _vm.mrcCodeChange },
                            model: {
                              value: _vm.model.mrcCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "mrcCode", $$v)
                              },
                              expression: "model.mrcCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language[
                                "system.certificate.certificateLegalperson"
                              ],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "certificateLegalperson"
                          }
                        },
                        [
                          _c("a-auto-complete", {
                            attrs: {
                              allowClear: "",
                              disabled: _vm.disabled || _vm.islock,
                              "data-source": _vm.certificateLegalpersonlist,
                              "filter-option": _vm.filterOption
                            },
                            on: { change: _vm.certificateLegalpersonChange },
                            model: {
                              value: _vm.model.certificateLegalperson,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "certificateLegalperson",
                                  $$v
                                )
                              },
                              expression: "model.certificateLegalperson"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["common.file"] +
                              "(" +
                              (_vm.totalFileSize / 1024 / 1024).toFixed(2) +
                              "M)",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          !_vm.disabled &&
                          !_vm.islock &&
                          _vm.totalFileSize > _vm.maxFileSize
                            ? _c("div", [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    "* " +
                                      _vm._s(
                                        _vm.language[
                                          "sysCertificate.warning.totalFileSizeIs"
                                        ]
                                      ) +
                                      ":" +
                                      _vm._s(
                                        (
                                          _vm.totalFileSize /
                                          1024 /
                                          1024
                                        ).toFixed(2)
                                      ) +
                                      "M;" +
                                      _vm._s(
                                        _vm.language[
                                          "sysCertificate.warning.CannotExceed"
                                        ]
                                      ) +
                                      _vm._s(_vm.maxFileSize / 1024 / 1024) +
                                      "M"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          !_vm.disabled &&
                          !_vm.islock &&
                          _vm.fileList.length > _vm.maxFileNumber
                            ? _c("div", [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    "* " +
                                      _vm._s(
                                        _vm.language[
                                          "sysCertificate.warning.totalFileNumberIs"
                                        ]
                                      ) +
                                      ":" +
                                      _vm._s(_vm.fileList.length) +
                                      " " +
                                      _vm._s(_vm.language["common.pcs"]) +
                                      ";" +
                                      _vm._s(
                                        _vm.language[
                                          "sysCertificate.warning.CannotExceed"
                                        ]
                                      ) +
                                      _vm._s(_vm.maxFileNumber) +
                                      " " +
                                      _vm._s(_vm.language["common.pcs"]) +
                                      "," +
                                      _vm._s(
                                        _vm.language[
                                          "sysCertificate.warning.uploadCompressedFiles"
                                        ]
                                      )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm.disabled
                            ? _c("div", [
                                !!this.model.filePaths
                                  ? _c(
                                      "div",
                                      [
                                        _c("j-upload", {
                                          attrs: {
                                            "file-type": "file",
                                            uploadSource: "platform",
                                            bizPath: "null",
                                            newWindowOpen: "true",
                                            value: this.model.filePaths,
                                            beforeUpload: _vm.beforeUpload,
                                            disabled: _vm.disabled,
                                            buttonVisible:
                                              !_vm.disabled &&
                                              !_vm.islock &&
                                              _vm.totalFileSize <=
                                                _vm.maxFileSize &&
                                              _vm.fileList.length <=
                                                _vm.maxFileNumber,
                                            number: 0,
                                            multiple: true
                                          },
                                          on: {
                                            change: _vm.handleChange,
                                            getAllFileList: _vm.getAllFileList,
                                            handleDelete: _vm.handleFileDelete
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(_vm._s(_vm.language["common.not"]))
                                    ])
                              ])
                            : _vm._e(),
                          !_vm.disabled
                            ? _c(
                                "div",
                                [
                                  _c("j-upload", {
                                    attrs: {
                                      "file-type": "file",
                                      text: this.language["common.clickUpload"],
                                      uploadSource: "platform",
                                      bizPath: "null",
                                      uploadTips: _vm.uploadTips,
                                      newWindowOpen: "true",
                                      value: this.model.filePaths,
                                      beforeUpload: _vm.beforeUpload,
                                      disabled: _vm.islock,
                                      buttonVisible:
                                        !_vm.disabled &&
                                        !_vm.islock &&
                                        _vm.totalFileSize <= _vm.maxFileSize &&
                                        _vm.fileList.length <=
                                          _vm.maxFileNumber,
                                      number: 0,
                                      multiple: true
                                    },
                                    on: {
                                      change: _vm.handleChange,
                                      getAllFileList: _vm.getAllFileList,
                                      handleDelete: _vm.handleFileDelete
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !!this.model.filePaths
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.downLoadAll }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language["common.all"] +
                                        _vm.language["download"]
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }